import React, { Component } from 'react'
import Header from '../components/Header'
import Card1 from '../components/cards/Card1'
import { connect } from 'react-redux';
import { changeStateValue } from '../redux/MainReducer';
import { getCategories } from '../actions/MainAction';
export class CategoryPage extends Component {
  openModal=(data, lang, lang_id=1)=>{
    // console.log(lang, lang_id)
    this.props.changeStateValue({
      name:"mainModal",
      value:{
        position:true,
        id: data?.id?data?.id:"",
        languages:
          {
            id:lang?.id?lang?.id:'',
            title:lang?.title?lang?.title:'',
            lang_id:lang_id
          }
        ,
        requiredsLang: ["title"],
        requireds:[],
        afterCallFunction:this.props.getCategories,
        afterParams:[],
        url:'admin-category'
      }
    })
  }

  componentDidMount(){
    this.props.getCategories();
  }
  render() {
    const {categoryData} = this.props;
    return (
      <div className='p-[40px] w-full'>
        <Header btn={true} onClickBtn={this.openModal.bind(this, "", "", 1)} title="Kateqoriyalar" />
        <div className='grid-full-250 grid grid-cols-2 mt-[20px]'>
            {
            categoryData?.map((data, i)=>{
                return(
                <Card1 
                    key={i}
                    onChangeLang={(id)=>this.openModal(data, data.translates.find(x=>x.lang_id==id), id)} 
                    title1={data?.translate?.title}
                    deleteUrl={`admin-category/${data?.id}`}
                    afterCallFunction={()=> this.props.getCategories()}
                />
                )
            })
            }
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state)=>({
  categoryData: state.Data.categoryData
});
const mapDispatchToProps = {changeStateValue, getCategories}
export default connect(mapStateToProps, mapDispatchToProps)(CategoryPage)
 